import { render, staticRenderFns } from "./CarInfractionsTable.vue?vue&type=template&id=1edc2866&"
import script from "./CarInfractionsTable.vue?vue&type=script&lang=ts&"
export * from "./CarInfractionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./car-infractions-table.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports